// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".top-swiper", {
	speed: 1000, // スライド変化時間
	loop: true,
	loopAdditionalSlides: 1,
	autoplay: {
		delay: 4000, //　スライダー表示時間
		disableOnInteraction: false,
	},
	pagination: {
		el: ".swiper-pagination",
		type: "bullets",
		clickable: true,
	},
});
const logoSwiper = new Swiper(".js-top-logoSwiper", {
	speed: 6000, // スライド変化時間
	loop: true,
	slidesPerView: 13, // 一度に表示する枚数
	allowTouchMove: false, // スワイプ無効
	autoplay: {
		delay: 0, //　スライダー表示時間
		disableOnInteraction: false,
	},
	breakpoints: {
		320: {
			slidesPerView: 5,
		},
		480: {
			slidesPerView: 5,
		},
		640: {
			slidesPerView: 6,
		},
		1024: {
			slidesPerView: 10,
		},
		1150: {
			slidesPerView: 13,
		}
	}
});

const slides = document.querySelectorAll('.js-courseSwiperMain .swiper-slide');
if (slides.length > 1) {
	//Main
	const courseSwiperThumbArgs = {
		// loop: true,
		spaceBetween: 30,
		slidesPerView: 4,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			320: {
				spaceBetween: 10,
			},
			640: {
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		}
	};
	const courseSwiperThumb = new Swiper(".js-courseSwiperThumb", courseSwiperThumbArgs);
	//Thumb
	const courseSwiperMainArgs = {
		loop: true,
		slidesPerView: 2,
		spaceBetween: 40,
		centeredSlides: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			640: {
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 40,
			}
		},
		thumbs: {
			swiper: courseSwiperThumb,
		},
	}
	const courseSwiperMain = new Swiper(".js-courseSwiperMain", courseSwiperMainArgs)
} else {
	document.getElementsByClassName('js-courseSlide')[0].classList.add('no-slide');
}